import styles from "../../../styles/Participant-Employment.module.css"
import { Button } from "primereact/button"
import { Actions, convertToLocalDateTime } from "../Utils/Utils"
import { Calendar } from "primereact/calendar"
import { requieredFieldIsMissing } from "../Utils/Utils"
import { renderRequireFieldErrorMessage } from "../Utils/Utils"
import { Dropdown } from "primereact/dropdown"
import {
  EngagementChannels,
  PreferredContactMethod,
  TransitionFutureContact,
  YesNo,
} from "../Types/Dropdowns"
import { substractOneMinute } from "../Utils/Utils"
import { addOneMinute } from "../Utils/Utils"
import EditorField from "../Utils/EditorField"
import { formatDate } from "../Utils/Utils"
import { useState } from "react"
import ContactForm from "./ContactForm"
import RadioButtonField from "../Utils/RadioButtonField"
import { RadioButton } from "primereact/radiobutton"
import PhoneField from "../Utils/PhoneField"
import TextField from "../Utils/TextField"
import { deleteConfirmationModal } from "../Utils/formikAux"
import { useContext } from "react"
import { UserContext } from "../../../context/userContext"
import { employmentApiUrl } from "../../../config/microservicesUrls"
import axios from "axios"
import { LoaderMedium } from "../../../components/Loaders"
import { validateEmail } from "../Utils/Utils"
import { InputText } from "primereact/inputtext"
import TransitionPlanView from "./TransitionPlanView"
const TransitionPlan = ({
  action,
  closeForm,
  transitionPlan,
  referral,
  updateData,
  viewMode,
}) => {
  const [showContactForm, setShowContactForm] = useState(false)
  const [editContact, setEditContact] = useState(null)
  const [deleteContact, setDeleteContact] = useState(null)

  const [engagementDate, setEngagementDate] = useState(
    transitionPlan
      ? convertToLocalDateTime(transitionPlan?.engagementDate)
      : formatDate(new Date())
  )
  const [engagementChannel, setEngagementChannel] = useState(
    transitionPlan
      ? EngagementChannels[transitionPlan?.engagementChannel]
      : EngagementChannels[0]
  )
  const [startTime, setStartTime] = useState(
    transitionPlan
      ? convertToLocalDateTime(transitionPlan?.startTime)
      : new Date()
  )
  const [endTime, setEndTime] = useState(
    transitionPlan
      ? convertToLocalDateTime(transitionPlan?.endTime)
      : addOneMinute(new Date())
  )
  const [futurePlans, setFuturePlans] = useState(
    transitionPlan?.futurePlans ?? ""
  )
  const [shortTermGoals, setShortTermGoals] = useState(
    transitionPlan?.shortTermGoals ?? ""
  )
  const [longTermGoals, setLongTermGoals] = useState(
    transitionPlan?.longTermGoals ?? ""
  )
  const [currentlyEmployed, setCurrentlyEmployed] = useState(
    transitionPlan ? YesNo[transitionPlan?.currentyEmployed] : ""
  )
  const [checkIn, setCheckIn] = useState(transitionPlan?.checkIn ?? "")
  const [IPS, setIPS] = useState(transitionPlan?.ips ?? "")
  const [futureContact, setFutureContact] = useState(
    transitionPlan ? TransitionFutureContact[transitionPlan?.futureContact] : ""
  )
  const [toolsStrategies, setToolsStrategies] = useState(
    transitionPlan?.toolsStrategies ?? ""
  )
  const [dissatisfied, setDissatisfied] = useState(
    transitionPlan?.dissatisfied ?? ""
  )
  const [reconnectIPS, setReconnectIPS] = useState(
    transitionPlan?.reconnectIPS ?? ""
  )
  const [benefitsContactEmail, setBenefictsContactEmail] = useState(
    transitionPlan?.benefitsContactEmail ?? ""
  )
  const [benefitsContactPhone, setBenefictsContactPhone] = useState(
    transitionPlan?.benefitsContactPhone ?? ""
  )
  const [benefitsContactName, setBenefictsContactName] = useState(
    transitionPlan?.benefitsContactName ?? ""
  )
  const [contacts, setContacts] = useState(transitionPlan?.contacts ?? [])
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const userCtx = useContext(UserContext)

  const buiildContacts = () => {
    return contacts.map((c) => {
      return {
        Name: c.name,
        TypesOfSupport: c.typesOfSupport,
        ContactType: c.contactType,
        SupportPhone: c.supportPhone,
        Schedule: c.schedule,
        Email: c.email,
      }
    })
  }
  const buildTransitionPlanModel = () => {
    return {
      ReferralId: referral?.id,
      OrganizationId: referral?.organizationId,
      ParticipantId: userCtx.current_participant_id,
      EngagementDate: engagementDate,
      EngagementChannel: EngagementChannels.indexOf(engagementChannel),
      StartTime: startTime,
      EndTime: endTime,
      FuturePlans: futurePlans,
      ShortTermGoals: shortTermGoals,
      LongTermGoals: longTermGoals,
      CurrentyEmployed: YesNo.indexOf(currentlyEmployed),
      CheckIn: checkIn,
      IPS: IPS,
      FutureContact: PreferredContactMethod.indexOf(futureContact),
      ToolsStrategies: toolsStrategies,
      Dissatisfied: dissatisfied,
      ReconnectIPS: reconnectIPS,
      BenefitsContactName: benefitsContactName,
      BenefitsContactEmail: benefitsContactEmail,
      BenefitsContactPhone: benefitsContactPhone,
      CompletedBy: userCtx.session.user.staff_id,
      Contacts: buiildContacts(),
    }
  }
  const cleanValues = () => {
    setEngagementDate(formatDate(new Date()))
    setEngagementChannel(EngagementChannels[0])
    setStartTime(new Date())
    setEndTime(addOneMinute(new Date()))
    setFuturePlans("")
    setShortTermGoals("")
    setLongTermGoals("")
    setCurrentlyEmployed("")
    setCheckIn("")
    setIPS("")
    setFutureContact("")
    setToolsStrategies("")
    setDissatisfied("")
    setReconnectIPS("")
    setBenefictsContactEmail("")
    setBenefictsContactName("")
    setBenefictsContactPhone("")
    setContacts([])
  }
  const validateFields = () => {
    let errors = {}
    if (benefitsContactEmail) {
      if (!validateEmail(benefitsContactEmail)) {
        errors.email = "Invalid email address"
      }
    }
    setErrors(errors)
    return Object.keys(errors).length === 0
  }
  const saveTransitionPlan = () => {
    if (validateFields()) {
      setLoading(true)
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${userCtx.tokenEmployment}`,
          },
        }
        return axios
          .post(
            `${employmentApiUrl()}${"/transitionPlan"}`,
            buildTransitionPlanModel(),
            config
          )
          .then((response) => {
            setLoading(false)
            updateData(response.data)
            closeForm()
            cleanValues()
          })
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    }
  }
  const contactsTable = () => {
    return (
      <table
        className={styles.table}
        style={{
          marginBottom: "1rem",
          paddingTop: "17px",
          paddingLeft: "16px",
          paddingBottom: "23px",
          paddingRight: "15px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Name
            </th>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Contact type
            </th>
            <th
              style={{
                fontSize: "14px",
                fontWeight: "700",
                lineHeight: "19px",
              }}
            >
              Schedule meeting?
            </th>
          </tr>
        </thead>
        <tbody>
          {contacts?.map((e) => {
            return (
              <tr key={e.id} style={{ height: "19px" }}>
                <td
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "19px",
                  }}
                >
                  {e.name}
                </td>
                <td
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "19px",
                  }}
                >
                  {e.contactType}
                </td>
                <td
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "19px",
                  }}
                >
                  {e.schedule ? "Yes" : "No"}
                </td>
                <td>
                  {
                    <div className={styles.table_actions}>
                      <Button
                        icon="pi pi-pencil"
                        type="button"
                        className={styles.rounded_btn}
                        onClick={() => {
                          setEditContact(e)
                          setShowContactForm(true)
                        }}
                        disabled={action === Actions.View}
                      />
                      <Button
                        icon="pi pi-trash"
                        type="button"
                        className={styles.rounded_btn}
                        onClick={() => {
                          setDeleteContact(e.id)
                        }}
                        disabled={action === Actions.View}
                      />
                    </div>
                  }
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }
  const footer = () => {
    return (
      <div className={styles.education_form_footer}>
        <Button
          label="Cancel"
          type="button"
          disabled={loading}
          onClick={() => {
            cleanValues()
            closeForm()
          }}
          className={`${styles.button} ${styles.button_secondary}`}
        />
        <Button
          label="Create employment transition"
          type="button"
          icon={loading ? "pi pi-spin pi-spinner" : ""}
          iconPos="right"
          disabled={loading}
          style={{ marginLeft: "1rem" }}
          className={`${styles.button}`}
          onClick={() => {
            saveTransitionPlan()
          }}
        />
      </div>
    )
  }
  const removeContact = (id) => {
    setContacts(contacts?.filter((p) => p.id !== id))
  }
  if (loading) {
    return <LoaderMedium />
  }
  return viewMode ? (
    <TransitionPlanView
      viewMode={viewMode}
      closeViewMode={() => {
        cleanValues()
        closeForm()
      }}
      loading={loading}
      transitionPlan={transitionPlan ?? referral?.transitionPlan}
    />
  ) : (
    <>
      <div className="main-content">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h1 className={styles.view_title}>{`${action === Actions.Add && !viewMode
              ? "Create employment transition plan"
              : "Employment transition plan"
            }`}</h1>
          <Button
            className={styles.rounded_btn}
            icon="pi pi-times"
            type="submit"
            disabled={loading}
            onClick={() => {
              cleanValues()
              closeForm()
            }}
          />
        </div>
        <div className={"card flex flex-wrap p-fluid " + styles.wrapper}>
          <h3 className={styles.view_subtitle}>Employment transition</h3>
          <h4
            style={{
              marginBottom: "2rem",
              fontWeight: 400,
              fontStyle: "normal",
              fontSize: "14px",
              lineHeight: "19px",
            }}
          >
            Creating an employment transition plan will close out the current
            supported employment services referral. In the future, a new
            referral must be created to enroll the participant back into
            supported employment services.
          </h4>
          <hr className={styles.line}></hr>
          <div className={styles.flex_card}>
            <div className={styles.field}>
              <label className={`${styles.label} ${styles.required}`}>
                Engagement date
              </label>
              <Calendar
                name="Engagement date"
                value={engagementDate}
                panelClassName="custom_calendar_panel"
                onChange={(e) => {
                  setEngagementDate(e.value)
                }}
                dateFormat="mm/dd/yy"
                showIcon
                className={`${styles.calendar} ${requieredFieldIsMissing(engagementDate) ? styles.invalid : ""
                  }`}
                disabled={action === Actions.View || viewMode?.view}
              />
              {renderRequireFieldErrorMessage(
                engagementDate,
                "Engagement date is required"
              )}
            </div>
            <div className={styles.field} style={{ flexGrow: "1" }}>
              <label className={`${styles.label} ${styles.required}`}>
                Engagement channel
              </label>
              <Dropdown
                value={engagementChannel}
                options={EngagementChannels}
                panelClassName="custom_dropdown_panel"
                onChange={(e) => {
                  setEngagementChannel(e.value)
                }}
                placeholder="Select a channel"
                style={{ height: "32px", alignItems: "center" }}
                disabled={action === Actions.View || viewMode?.view}
              />
            </div>
            <div className={styles.field}>
              <label className={`${styles.label} ${styles.required}`}>
                Start time
              </label>
              <Calendar
                name="Start time"
                value={startTime}
                timeOnly
                panelClassName="custom_calendar_panel"
                onChange={(e) => {
                  setStartTime(e.value)
                }}
                hourFormat="12"
                showIcon
                icon="pi pi-clock"
                className={`${styles.calendar} ${requieredFieldIsMissing(startTime) ? styles.invalid : ""
                  }`}
                maxDate={substractOneMinute(endTime)}
                disabled={action === Actions.View || viewMode?.view}
              />
              {renderRequireFieldErrorMessage(
                startTime,
                "Start time is required"
              )}
            </div>
            <div className={styles.field}>
              <label className={`${styles.label} ${styles.required}`}>
                End time
              </label>
              <Calendar
                name="End time"
                value={endTime}
                timeOnly
                panelClassName="custom_calendar_panel"
                hourFormat="12"
                onChange={(e) => {
                  setEndTime(e.value)
                }}
                showIcon
                icon="pi pi-clock"
                className={`${styles.calendar} ${requieredFieldIsMissing(endTime) ? styles.invalid : ""
                  }`}
                minDate={addOneMinute(startTime)}
                disabled={action === Actions.View || viewMode?.view}
              />
              {renderRequireFieldErrorMessage(endTime, "End time is required")}
            </div>
          </div>
          <EditorField
            value={futurePlans}
            onTextChange={(e) => {
              setFuturePlans(e)
            }}
            label="What are your future plans?"
            disabled={action === Actions.View || viewMode?.view}
          />
          <EditorField
            value={shortTermGoals}
            onTextChange={(e) => {
              setShortTermGoals(e)
            }}
            label="What are your short-term goals?"
            disabled={action === Actions.View || viewMode?.view}
          />
          <EditorField
            value={longTermGoals}
            onTextChange={(e) => {
              setLongTermGoals(e)
            }}
            label="What are your long term goals?"
            disabled={action === Actions.View || viewMode?.view}
          />
          <hr className={styles.line}></hr>
          {contacts?.length > 0 && contactsTable()}
          {deleteConfirmationModal(
            deleteContact,
            setDeleteContact,
            removeContact,
            "Contact"
          )}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h4
              style={{
                paddingTop: "10px",
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "22px",
                color: "#383838",
              }}
            >
              Who can help with your career goals?
            </h4>
            <Button
              label="Add new contact"
              className={styles.button}
              style={{
                height: "38px",
                fontSize: "16px",
                marginBottom: "20px",
              }}
              disabled={action === Actions.View || viewMode?.view}
              onClick={() => {
                setShowContactForm(true)
              }}
              type="button"
            />
          </div>
          <hr className={styles.line}></hr>
          <RadioButtonField
            short
            label={"Are you currently employed?"}
            setValue={setCurrentlyEmployed}
            value={currentlyEmployed}
            disabled={action === Actions.View || viewMode?.view}
          />
          <EditorField
            value={checkIn}
            onTextChange={(e) => {
              setCheckIn(e)
            }}
            label="How often would you like someone to check-in with you about your employment and who should check-in with you?"
            disabled={action === Actions.View || viewMode?.view}
          />
          <EditorField
            value={IPS}
            onTextChange={(e) => {
              setIPS(e)
            }}
            label="When would be a good time to ask you about returning to IPS for help with employment or education and Who should contact you?"
            disabled={action === Actions.View || viewMode?.view}
          />
          <div className={styles.field}>
            <label className={styles.label}>
              {"How would you like to be contacted in the future?"}
            </label>
            <div className={styles.radio_btn_wrapper}>
              <div
                className={styles.radio_btn}
                style={{ padding: "20px 10px" }}
              >
                <RadioButton
                  inputId={TransitionFutureContact[0]}
                  value={TransitionFutureContact[0]}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    setFutureContact(e.value)
                  }}
                  checked={futureContact === TransitionFutureContact[0]}
                  disabled={action === Actions.View || viewMode?.view}
                />
                <label
                  htmlFor={TransitionFutureContact[0]}
                  className={styles.inline_label}
                >
                  {TransitionFutureContact[0]}
                </label>
              </div>
              <div
                className={styles.radio_btn}
                style={{ padding: "20px 10px" }}
              >
                <RadioButton
                  inputId={TransitionFutureContact[1]}
                  value={TransitionFutureContact[1]}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    setFutureContact(e.value)
                  }}
                  disabled={action === Actions.View || viewMode?.view}
                  checked={futureContact === TransitionFutureContact[1]}
                />
                <label
                  htmlFor={TransitionFutureContact[1]}
                  className={styles.inline_label}
                >
                  {TransitionFutureContact[1]}
                </label>
              </div>
              <div
                className={styles.radio_btn}
                style={{ padding: "20px 10px" }}
              >
                <RadioButton
                  inputId={TransitionFutureContact[2]}
                  value={TransitionFutureContact[2]}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    setFutureContact(e.value)
                  }}
                  disabled={action === Actions.View || viewMode?.view}
                  checked={futureContact === TransitionFutureContact[2]}
                />
                <label
                  htmlFor={TransitionFutureContact[2]}
                  className={styles.inline_label}
                >
                  {TransitionFutureContact[2]}
                </label>
              </div>
              <div
                className={styles.radio_btn}
                style={{ padding: "20px 10px" }}
              >
                <RadioButton
                  inputId={TransitionFutureContact[3]}
                  value={TransitionFutureContact[3]}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    setFutureContact(e.value)
                  }}
                  disabled={action === Actions.View || viewMode?.view}
                  checked={futureContact === TransitionFutureContact[3]}
                />
                <label
                  htmlFor={TransitionFutureContact[3]}
                  className={styles.inline_label}
                >
                  {TransitionFutureContact[3]}
                </label>
              </div>
              <div
                className={styles.radio_btn}
                style={{ padding: "20px 10px" }}
              >
                <RadioButton
                  inputId={TransitionFutureContact[4]}
                  value={TransitionFutureContact[4]}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    setFutureContact(e.value)
                  }}
                  disabled={action === Actions.View || viewMode?.view}
                  checked={futureContact === TransitionFutureContact[4]}
                />
                <label
                  htmlFor={TransitionFutureContact[4]}
                  className={styles.inline_label}
                >
                  {TransitionFutureContact[4]}
                </label>
              </div>
              <div
                className={styles.radio_btn}
                style={{ padding: "20px 10px" }}
              >
                <RadioButton
                  inputId={TransitionFutureContact[5]}
                  value={TransitionFutureContact[5]}
                  style={{ margin: "0" }}
                  onChange={(e) => {
                    setFutureContact(e.value)
                  }}
                  disabled={action === Actions.View || viewMode?.view}
                  checked={futureContact === TransitionFutureContact[5]}
                />
                <label
                  htmlFor={TransitionFutureContact[5]}
                  className={styles.inline_label}
                >
                  {TransitionFutureContact[5]}
                </label>
              </div>
            </div>
          </div>
          <EditorField
            value={toolsStrategies}
            onTextChange={(e) => {
              setToolsStrategies(e)
            }}
            label="What are some tools/coping strategies you use or have used in the past on the job to manage stress?"
            disabled={action === Actions.View || viewMode?.view}
          />
          <EditorField
            value={dissatisfied}
            onTextChange={(e) => {
              setDissatisfied(e)
            }}
            label="How would you know if you started to feel dissatisfied with your job or that you were having other problems?"
            disabled={action === Actions.View || viewMode?.view}
          />
          <EditorField
            value={reconnectIPS}
            onTextChange={(e) => {
              setReconnectIPS(e)
            }}
            label="What are some reasons to reconnect to IPS in the future?"
            disabled={action === Actions.View || viewMode?.view}
          />
          <hr className={styles.line}></hr>
          <h4 className={styles.view_subtitle}>Benefits planner</h4>
          <h4
            style={{
              marginBottom: "2rem",
              fontWeight: 400,
              fontStyle: "normal",
              fontSize: "14px",
              lineHeight: "19px",
            }}
          >
            Creating an employment transition plan will close out the current
            supported employment services referral. In the future, a new
            referral must be created to enroll the participant back into
            supported employment services.
          </h4>
          <TextField
            label={"Contact name"}
            value={benefitsContactName}
            setValue={setBenefictsContactName}
            disabled={action === Actions.View || viewMode?.view}
          />
          <div
            className={styles.field}
            style={{ marginBottom: "0rem", width: "100" }}
          >
            <label
              className={`${styles.label}`}
              style={{ marginBottom: "5px" }}
            >
              {"Contact email"}
            </label>
            <InputText
              value={benefitsContactEmail}
              style={{ width: "100%" }}
              onChange={(e) => {
                setBenefictsContactEmail(e.target.value)
                setErrors({ ...errors, email: "" })
              }}
              className={errors.email ? "p-invalid" : ""}
              disabled={action === Actions.View || viewMode?.view}
            />
            {errors.email && (
              <span style={{ color: "red" }}>{errors.email}</span>
            )}
          </div>
          <PhoneField
            label={"Contact phone"}
            value={benefitsContactPhone}
            setValue={setBenefictsContactPhone}
            style={{ width: "100%" }}
            lblStyle={{ marginTop: "0px", marginBottom: "6px" }}
            disabled={action === Actions.View || viewMode?.view}
          />
          <hr className={styles.line} style={{ marginTop: "30px" }}></hr>
          {action !== Actions.View && !viewMode && footer()}
        </div>
      </div>
      <ContactForm
        visible={showContactForm}
        setVisible={setShowContactForm}
        setValue={setContacts}
        contacts={contacts}
        edit={editContact}
        setEdit={setEditContact}
      />
    </>
  )
}
export default TransitionPlan
